import * as React from 'react';
import { SVGProps } from 'react';

const IconIncidentSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m6 0 .957 4.013L12 1.5 8.625 5.51l2.625.865-3 1.125L9 12 6 8.205l-2.15 1.92V7.5L0 7.125l3.375-1.616-1.5-2.884 3 .75L6 0Z" />
  </svg>
);
export default IconIncidentSizeXs;
